export default __webpack_public_path__ + "static/media/tds02.bce055b3.png";